import React from "react";

function NotFound() {
  return (
    <div className="notfound-card" style={{ textAlign: "center", marginTop: "50px" }}>
      <h1 className="notfound-404">404</h1>
      <h2 className="notfound-titre">Page introuvable</h2>
      <p className="notfound-texte">Oups! La page que vous cherchez ne semble plus disponible.</p>
      <a href="/boutique" className="notfound-btn">⬅ Retour à l’accueil</a>
    </div>
  );
}

export default NotFound;
